import { Tag } from '@cian/components';
import * as React from 'react';

import { IGeoDistrictTag } from '../../../../state/tags/definitions/geo/district';
import { TagNew } from '../../TagNew';

import { tagThemeSmall } from '../../tag_theme';

export interface IGeoDistrictTagItemProps {
  tag: IGeoDistrictTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoDistrictTagItem = (props: IGeoDistrictTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.text}
    </TagComponent>
  );
};
